module.exports = __webpack_public_path__ + "img/q14.605871f8.png";